import type { ComponentPropsWithoutRef } from 'react';
import type { AvatarData } from '@/api/gen/_model/avatarData';
import { cn } from '@/utils/tailwind.util';
import { AvatarSpriteLayers } from '../avatarSpriteLayers';
import { AVATAR_BG_COLOR, type AvatarShape, SHAPE_MAP } from '../constants/avatar.constants';

/** Sprite sheet: 432×256, 9 columns × 4 rows → each frame 48×64 */
const BASE_SPRITE_PIXEL_SIZE = 96;
const SPRITE_SHEET_WIDTH = 432;
const SPRITE_FRAME_WIDTH = 48;
const SPRITE_FRAME_HEIGHT = 64;
export const SpriteAvatar = ({
  avatarData,
  backgroundColor,
  spritePixelSize,
  shape = 'circle',
  className,
  style,
  ...props
}: ComponentPropsWithoutRef<'div'> & {
  avatarData: AvatarData;
  backgroundColor?: string;
  spritePixelSize: number;
  shape?: AvatarShape;
}) => {
  const spriteScale = spritePixelSize / BASE_SPRITE_PIXEL_SIZE;
  return <div className={cn('relative inline-flex shrink-0 items-center justify-center overflow-hidden border border-[rgba(28,27,31,0.04)]', SHAPE_MAP[shape], className)} style={{
    backgroundColor: backgroundColor ?? AVATAR_BG_COLOR,
    width: spritePixelSize,
    height: spritePixelSize,
    ...style
  }} {...props} data-sentry-component="SpriteAvatar" data-sentry-source-file="SpriteAvatar.tsx">
      <div className="relative shrink-0" style={{
      top: 15 * spriteScale,
      left: 1 * spriteScale,
      width: SPRITE_FRAME_WIDTH * 2 * spriteScale,
      height: SPRITE_FRAME_HEIGHT * 2 * spriteScale,
      imageRendering: 'pixelated'
    }}>
        <AvatarSpriteLayers avatarData={avatarData} layerStyle={{
        backgroundRepeat: 'no-repeat',
        backgroundPosition: '0 0',
        backgroundSize: `${SPRITE_SHEET_WIDTH * 2 * spriteScale}px auto`
      }} data-sentry-element="AvatarSpriteLayers" data-sentry-source-file="SpriteAvatar.tsx" />
      </div>
    </div>;
};